import { render, staticRenderFns } from "./PostIndexSettingsView.vue?vue&type=template&id=e99e393a"
import script from "./PostIndexSettingsView.vue?vue&type=script&lang=js"
export * from "./PostIndexSettingsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports